export enum FilterTypes {
  EMAIL = 'email',
  PHONE = 'phoneNumber',
  NAME = 'name',
}
